/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Svg from '../Svg/Svg';

class TopNavigationBar extends Component {

    constructor(props) {
        super(props);
        this.popupHelpContent = this.popupHelpContent.bind(this);
    }

    popupHelpContent(){
        let pathName  = window.location.pathname;
        let forwardIndex = pathName.lastIndexOf('/');
        let value = pathName.substring(forwardIndex+1);
        const productDeliveryType = this.props.bookBuildContent.productDeliveryType;
        
        if(value === 'book-details' && productDeliveryType !=='vitalsource'){
            window.location.assign('?appcue=890d57bd-7fc9-466a-82c2-6140b1517eb9');
        }
        if (value === 'book-details' && productDeliveryType ==='vitalsource') {
            window.location.assign('?appcue=0a26bf2f-49a3-45bb-9bb5-8dd6265292e3');
        }        
        if(value === 'order-details' && productDeliveryType !== 'vitalsource'){
            window.location.assign('?appcue=6c39b75e-9802-43fd-a2db-9d62b4ba1dd6');
        }
        if(value === 'order-details' && productDeliveryType === 'vitalsource'){
            window.location.assign('?appcue=c0211cea-5075-43f3-b48d-b2471d620ecb');
        }
        if(value == 'product-offer-details'){
            window.location.assign('?appcue=892a2ec2-30a8-478d-9a35-f0e933c8c96e');
        }
        if(value == 'course-details'){
            window.location.assign('?appcue=12e5cd98-4c32-4a45-89c1-42b98533cb60');
        }
    }

   
    render() {
        return (
            <div className="top-navigation-bar pe-row">
                <ul className="nav-links">
                    <li className="active"><a href="/admintool">Home</a></li>
                    <div className= "question-icon" onClick={this.popupHelpContent}>
                        <Svg svgString="help-fill-24"/>
                    </div>
   
                </ul>
                <div>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        bookBuildContent: state.bookBuildContent,
    };
}
export default  connect(mapStateToProps)(TopNavigationBar);



// WEBPACK FOOTER //
// ./src/components/widgets/TopNavigationBar/TopNavigationBar.js